<template>
  <header id="topbar" class="topbar" role="header">
    <div class="topbar-fixed">
      <el-row :gutter="10" class="menu">
        <el-col :md="4" :lg="6">
          <div class="logo">
            <a href="https://artlas.huma-num.fr" target='_blank' :title="$t('pages.home.title')">
              <img src="static/img/basart_logo_BD.gif"
                alt="Artlas"
                :title="$t('pages.home.explanation')">
            </a>
          </div>
        </el-col>
        <el-col :md="18" :lg="16">
          <form-simple></form-simple>
        </el-col>
        <el-col :md="2" :lg="2">
          <lang-menu></lang-menu>
        </el-col>
      </el-row>
    </div>
  </header>
</template>

<script>
import FormSimple from './FormSimple.vue'
import LangMenu from '../LangMenu/LangMenu.vue'

import {
  Col,
  Row,
  Tooltip
} from 'element-ui'

export default {
  name: 'topbar',
  components: {
    formSimple: FormSimple,
    LangMenu,
    elCol: Col,
    elRow: Row,
    elTooltip: Tooltip
  }
}
</script>

<style>
.topbar {
  position: relative;
  z-index: 900;
  width: 100%;
  height: 67px;
}
.menu {
  background: #212121;
  color: white;
  margin: 0;
}
.submenu {
  overflow: hidden;
  height: 0;
  transition: height .3s;
}
.submenu.show {
  height: 61px;
}
.el-col {
  padding-top: 6px;
}
.logo a {
  display: block;
  width: auto;
  height: 65px;
  float: left;
  padding: 0 16px;
}
.logo img {
  height: 100%;
  width: auto;
  vertical-align: middle;
}
.database {
  float: left;
  height: 40px;
  line-height: 40px;
  padding-left: 4px;
  border-left: solid 1px white;
  display: none;
  font-weight: bold;
  font-size: 16px;
}
.database a {
  color: white;
  text-decoration: unset;
}
.database img {
  padding: 0 10px;
  height: 36px;
  vertical-align: middle;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0
}
.el-menu-item i.el-icon-search {
  margin-right: 0;
}
@media (min-width: 992px) {
  .topbar .el-col {
    padding-top: 0;
    height: 100%;
    display: flex;
    align-items: center;
    height: 67px;
  }
}
@media (min-width: 1208px) {
  .database {
    display: flex;
  }
  .topbar-fixed {
    overflow: hidden;
    position: absolute;
    top: 0;
    width: 100%;
  }
  /* .topbar {
    padding-top: 67px;
  } */
}
</style>



// WEBPACK FOOTER //
// src/components/TopBar/TopBar.vue